import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import EditWorkAreaModal from 'modules/locations/components/EditWorkArea'

const EditWorkAreaModalPage = () => {
  const { navigation } = useNavigation()
  const { id, workAreaId } = useStrictParams<'id' | 'workAreaId'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.workAreas.fullPath({ id }))
  }

  return <EditWorkAreaModal locationId={+id} workAreaId={+workAreaId} onClose={onClose} />
}

export default EditWorkAreaModalPage
